import React from "react";
import "./PromoBot.css";
import { getData } from "app/data";
import RequestAMemo from "components/PageHeader/TitleSubtitlePageHeader/RequestAMemo";
import Specifications from "components/Main/pages/Robots/components/Specifications";
import Intro from "components/Main/pages/Robots/components/Intro";
import WhatItCan from "components/Main/pages/Robots/components/WhatItCan";
import UseCases from "components/Main/pages/Robots/components/UseCases";
import OtherRobo from "components/Main/pages/Robots/components/OtherRobo";
import WaitingFor from "components/Banner/WaitingFor";
import PageHeader from "components/PageHeader/TitleSubtitlePageHeader/MerchantService";

export default function Index() {
  const data = getData("promobotData")
  return (
    <>
      <div className="promobot-page">
        <PageHeader
          title="promobot"
          subtitle="promobot_header_sub_title"
          subtitleColorGreen={false}
        />
        <div className="main-background">
          <Intro data={data} />
          <WhatItCan data={data} />
          <Specifications data={data} />
          <UseCases data={data} />
        </div>
        <OtherRobo except="PromoBot" />
        <WaitingFor />
      </div>
    </>
  );
}
